module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-N.f8d75c5e.png";